<div style="height: 100%" data-cy="referral-manager-container">
  <div class="section-header" data-cy="referral-manager-header">
    <div class="section-header-title" data-cy="referral-manager-title">Referral Management</div>
  </div>
  <div style="display: flex; flex-direction: column; flex: 1; height: 100%" data-cy="referral-manager-content">
    <div style="display: flex; flex-direction: row; height: 100%;width: 100%;" data-cy="referral-manager-columns">
      <div class="column1" style="border: 1px solid var(--tdo-blue); height: 95%;margin-top: 10px;" data-cy="referral-manager-left-column">
        <h6 style="background-color: var(--tdo-primary); color: white; width: 100%; padding-left: 20px" data-cy="referral-manager-unhandled-header">Referral Requests</h6>
        <div style="display: flex; flex-direction: column; flex: 1; height: inherit" data-cy="referral-manager-list-container">
          <div style="flex-basis: fit-content; padding: 0px 10px 0px 10px" data-cy="referral-manager-status-filter">
            @if (referralStatus.length > 0) {
              <app-validvalueselect style="width:90%" [disabled]="false"
                data-cy="referral-manager-status-select" validvaluename="enumReferralStatus"
                [showNoneOption]="false" vvlabel="List Referrals By Status"
                [dataSource]="referralStatus"
                (selectedValueChange)="changeStatus($event)"
                [(selectedValue)]="referralFilter.referralStatusID"
              vvplaceholder="Status"></app-validvalueselect>
            }
            <mat-icon matTooltip="Reload List"
              style="color: var(--tdo-primary); margin-bottom: 10px; margin-left: 8px; cursor: pointer;"
              (click)="getReferralList(true)" data-cy="referral-manager-reload-button">autorenew
            </mat-icon>
          </div>

          <div style="flex-basis: fit-content; padding: 0px 10px 0px 10px" data-cy="referral-manager-search-container">
            <app-tdo-input placeholder="Search" [(ngModel)]="referralSearch"
            (input)="changeFilter($event)" data-cy="referral-manager-search-input"></app-tdo-input>
          </div>
          @if (isLoading) {
            <div style="width: 100%; height: 100%; vertical-align: center" data-cy="referral-manager-loading">
              <app-tdo-progress-spinner data-cy="referral-manager-spinner"></app-tdo-progress-spinner>
            </div>
          }
          @if (!isLoading) {
            <mat-button-toggle-group style="height: 80%" data-cy="referral-manager-list">
              @for (ref of referralsFilter; track ref) {
                <mat-button-toggle [checked]="ref === selectedRef" class="vertical"
                  [value]="ref" (click)="selectRef(ref)"
                  [ngClass]="{'selectedCLass': ref === selectedRef}" data-cy="referral-manager-list-item">
                  <div style="display: flex; flex-direction:row; flex: 1; width: 100%" data-cy="referral-manager-item-content">
                    <div style="display: flex; flex-direction:column; flex: 1; width: 70%" data-cy="referral-manager-item-details">
                      <div style="display: flex; flex-direction:row" data-cy="referral-manager-item-received">
                        <span style="font-weight: bold" data-cy="referral-manager-received-label">Received:</span>
                        <span class="span" data-cy="referral-manager-received-date">{{getLocalDate(ref.ReferralTime) | date: 'short'}} </span>
                      </div>
                      <div style="display: flex; flex-direction:row" data-cy="referral-manager-item-from">
                        <span style="font-weight: bold" data-cy="referral-manager-from-label">From:</span>
                        @for (doc of referringDocs | ReferralDoctorPipe: ref.RefDoctorID; track doc) {
                          <span class="span" data-cy="referral-manager-from-doctor"
                          >{{doc.FullName}}</span>
                        }
                      </div>
                      <div style="display: flex; flex-direction:row" data-cy="referral-manager-item-patient">
                        <span style="font-weight: bold" data-cy="referral-manager-patient-label">Patient:</span>
                        <span class="span" data-cy="referral-manager-patient-name">{{ref.Patient_FirstName}} {{ref.Patient_LastName}}
                        (DOB: {{ref.Patient_DOB | date: 'MM-dd-yyyy'}})</span>
                      </div>
                      <div style="display: flex; flex-direction:row" data-cy="referral-manager-item-for">
                        <span style="font-weight: bold" data-cy="referral-manager-for-label">For:</span>
                        @for (docTDO of listTDOProvidersDoctors | ProviderReferringDoctorPipe: ref.ProviderID; track docTDO) {
                          <span class="span" data-cy="referral-manager-for-doctor"
                            >
                          Dr. {{docTDO.dataContact.FirstName}} {{docTDO.dataContact.LastName}} </span>
                        }
                      </div>
                    </div>
                    <img style="object-fit: contain" [src]="getIconByEnumType(ref.enumReferralScheduleTypeID)"
                      [matTooltip]="imageTooltip" data-cy="referral-manager-item-icon"/>
                    </div>
                  </mat-button-toggle>
                }
              </mat-button-toggle-group>
            }
            <div style="width: 100%; display: flex; justify-content:center; padding-top: 25px;" data-cy="referral-manager-actions">
              <tdo-button (click)="cancel(selectedRef)" class="tdo-button tdox-btn-danger"
                style="padding:4px;margin-left: 10px;" data-cy="referral-manager-remove-button">Remove Referral Request
              </tdo-button>
            </div>
          </div>
        </div>
        @if (!selectedRef) {
          <div class="column2" data-cy="referral-manager-empty-right-column">
            @if (errorLoading) {
              <div style="display: flex; margin: auto;" data-cy="referral-manager-error-loading">
                <span style="color: red; font-weight: bold">Error loading referral</span>
              </div>
            }
            @if (referralLoading) {
              <div style="display: flex; margin: auto;" data-cy="referral-manager-loading">
                <app-tdo-progress-spinner></app-tdo-progress-spinner>
              </div>
            }
          </div>
        }
        @if (selectedRef) {
          <div class="column2" data-cy="referral-manager-right-column">
            <div style="display: flex; flex-direction: column; margin-top: 10px; width: 50%" data-cy="referral-manager-detail-cards">
              <mat-card class="Card-style" style="height: 160px" data-cy="referral-manager-doctor-card">
                <mat-card-title-group>
                  <mat-card-title class="Card-title" data-cy="referral-manager-doctor-title">Referring Doctor</mat-card-title>
                </mat-card-title-group>
                @if (this.selectedDoc) {
                  <mat-card-content data-cy="referral-manager-doctor-content">
                    <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start" data-cy="referral-manager-doctor-details">
                      <span style="font-weight: bold" class="span" data-cy="referral-manager-doctor-name">{{this.selectedDoc.FullName}}</span>
                      <span class="span" data-cy="referral-manager-doctor-email">{{this.selectedDoc.email}}</span>
                      <span class="span" data-cy="referral-manager-doctor-phone">{{this.selectedDoc.phone}}</span>
                    </div>
                    <div style="width: 100%; display: flex;flex-direction: row; border-top: solid 1px var(--tdo-blue-light)" data-cy="referral-manager-doctor-actions">
                      @if (!matchReferralDoctor) {
                        <span
                        style="width: 90%; padding-left: 5px; padding-top: 10px" data-cy="referral-manager-doctor-no-match">No match found</span>
                      }
                      @if (matchReferralDoctor && this.dataReferralDoctor.FullName) {
                        <span
                        style="width: 90%; padding-left: 5px; padding-top: 10px" data-cy="referral-manager-doctor-match">{{this.dataReferralDoctor.FullName}}</span>
                      }
                      @if (listTDOReferralDoctor.length > 0 && selectedRef.enumReferralStatusID === EnumReferralStatusPending) {
                        <div
                          style="padding-left: 5px; padding-top: 10px"
                          matTooltip="Find Referring Doctor"
                          (click)="findDrOnList($event)" data-cy="referral-manager-doctor-find-button">
                          <!--                  <lucide-icon name="settings" [size]="20"></lucide-icon>-->
                          <dx-button icon="find"></dx-button>
                        </div>
                      }
                      @if (selectedRef.enumReferralStatusID === EnumReferralStatusPending) {
                        <div
                          style="padding-left: 5px; padding-top: 10px" matTooltip="Add new referring doctor"
                          (click)="createReferringDoctor($event)" data-cy="referral-manager-doctor-add-button">
                          <!--                  <lucide-icon name="plus-circle" [size]="20"></lucide-icon>-->
                          <dx-button icon="add"></dx-button>
                        </div>
                      }
                    </div>
                  </mat-card-content>
                }
              </mat-card>
              <mat-card class="Card-style" style="height: 180px; margin-top: 5px" data-cy="referral-manager-patient-card">
                <mat-card-title-group>
                  <mat-card-title class="Card-title" data-cy="referral-manager-patient-title">Patient</mat-card-title>
                </mat-card-title-group>
                <mat-card-content data-cy="referral-manager-patient-content">
                  <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start" data-cy="referral-manager-patient-details">
                    <span class="span" data-cy="referral-manager-patient-fullname">{{this.selectedRef.Patient_LastName}}
                    , {{this.selectedRef.Patient_FirstName}} {{this.selectedRef.Patient_MidName}}</span>
                    <span class="span" data-cy="referral-manager-patient-dob">DOB: {{this.selectedRef.Patient_DOB | date: 'MM-dd-yyyy'}}</span>
                    <span class="span" data-cy="referral-manager-patient-email">{{this.selectedRef.Patient_email}}</span>
                    <span class="span" data-cy="referral-manager-patient-phone">{{this.selectedRef.Patient_phone | formatPhone}}</span>
                  </div>
                  <div style="width: 100%; display: flex;flex-direction: row; border-top: solid 1px var(--tdo-blue-light)">
                    <div style="width: 85%; display: flex;flex-direction: row;">
                      @if (!matchReferralPatient && !isShowPatientSearch) {
                        <span
                        style="width: 90%; padding-left: 5px; padding-top: 10px">No match found</span>
                      }
                      @if (matchReferralPatient && !isShowPatientSearch) {
                        <span
                        style="width: 90%; padding-left: 5px; padding-top: 10px">{{this.matchPatientFullName}}</span>
                      }
                      @if (isShowPatientSearch) {
                        <div style="width: 100%; height: 100%; padding: 4px 10px 1px 10px;">
                          <div style="display: flex; width: 100%; height: fit-content;">
                            <div
                              style="color: var(--tdo-primary-accent); height: fit-content; font-weight: 500; flex-basis: fit-content;">
                              Patient Name:
                            </div>
                            <div style="flex: 1;"></div>
                            <div matTooltip="Close" (click)="closeSearch()"
                              style="cursor: pointer; height: 20px; flex-basis: fit-content;">
                              <lucide-icon name="x" [size]="20"></lucide-icon>
                            </div>
                          </div>
                          <div style="background-color: var(--tdo-background); padding: 2px; border-radius: 6px;">
                            <tdo-patient-search #tps (patientSelect)="selectPatient($event)"  data-cy="referral-manager-patient-search"
                            [isChangeUser]="false"></tdo-patient-search>
                          </div>
                        </div>
                      }
                    </div>
                    @if (selectedRef.enumReferralStatusID === EnumReferralStatusPending) {
                      <div matTooltip="Search Patient"
                        style="cursor: pointer; width: fit-content; height: 26px; margin-left: auto; margin-right: auto; color: var(--tdo-primary-accent); padding-top: 10px"
                        (click)="onSearchPatientClick()">
                        <!--                  <lucide-icon name="search" [size]="20"></lucide-icon>-->
                        <dx-button icon="find"></dx-button>
                      </div>
                    }
                    @if (selectedRef.enumReferralStatusID === EnumReferralStatusPending) {
                      <div
                        style="padding-left: 5px; padding-top: 10px; margin-left: auto" matTooltip="Add new Patient"
                        (click)="handlePatient($event)">
                        <!--                  <lucide-icon name="plus-circle" [size]="20"></lucide-icon>-->
                        <dx-button icon="add"></dx-button>
                      </div>
                    }
                  </div>
                </mat-card-content>
              </mat-card>
              <mat-card class="Card-style" style="height: 180px; margin-top: 5px" data-cy="referral-manager-insurance-card">
                <mat-card-title-group>
                  <mat-card-title class="Card-title" data-cy="referral-manager-insurance-title">Insurance</mat-card-title>
                </mat-card-title-group>
                <mat-card-content data-cy="referral-manager-insurance-content">
                  <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start" data-cy="referral-manager-insurance-details">
                    <span class="span" data-cy="referral-manager-insurance-holder">Policy Holder: {{this.selectedRef.Insurance_LastName}}
                    , {{this.selectedRef.Insurance_FirstName}}</span>
                    <span class="span" data-cy="referral-manager-insurance-dob">DOB: {{this.selectedRef.Insurance_DOB | date: 'MM-dd-yyyy'}}</span>
                    <span class="span" data-cy="referral-manager-insurance-company">Insurance Company:{{this.selectedRef.Insurance_Company}}</span>
                    <span class="span" data-cy="referral-manager-insurance-number">Insurance Number:{{this.selectedRef.Insurance_Number}}</span>
                  </div>
                  <div
                    style="width: 100%; display: flex;flex-direction: row; border-top: solid 1px var(--tdo-blue-light)">
                    @if (!matchReferralInsurance) {
                      <span
                      style="width: 90%; padding-left: 5px; padding-top: 10px">No match found</span>
                    }
                    @if (matchReferralInsurance) {
                      <span
                      style="width: 90%; padding-left: 5px; padding-top: 10px">{{this.matchReferralInsuranceName}}</span>
                    }
                    @if (listMatchTDOInsurances.length > 0 && selectedRef.enumReferralStatusID === EnumReferralStatusPending) {
                      <div
                        style="padding-left: 5px; padding-top: 10px"
                        matTooltip="Find Patient Insurance"
                        (click)="findPatientInsuranceOnList($event)">
                        <!--                  <lucide-icon name="settings" [size]="20"></lucide-icon>-->
                        <dx-button icon="find"></dx-button>
                      </div>
                    }
                    @if (selectedRef.enumReferralStatusID === EnumReferralStatusPending) {
                      <div
                        style="padding-left: 5px; padding-top: 10px; margin-left: auto" matTooltip="Add new Insurance"
                        (click)="handleInsurance($event)">
                        <!--                  <lucide-icon name="plus-circle" [size]="20"></lucide-icon>-->
                        <dx-button icon="add"></dx-button>
                      </div>
                    }
                  </div>
                </mat-card-content>
              </mat-card>
              <mat-card class="Card-style" style="height: 180px; margin-top: 5px" data-cy="referral-manager-attachments-card">
                <mat-card-title-group>
                  <mat-card-title class="Card-title" data-cy="referral-manager-attachments-title">Attachments</mat-card-title>
                  <dx-button  icon="copy"   (onClick)="onCopyAttachments()"  hint="Copy attachment(s) to patient record" ></dx-button>
                </mat-card-title-group>
                <mat-card-content data-cy="referral-manager-attachments-content">
                  <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start" data-cy="referral-manager-attachments-grid">
                    <mat-grid-list cols="4" rowHeight="100px" data-cy="referral-manager-attachments-list">
                      @for (img of this.selectedRef.dataReferralAttachments; track img) {
                        <mat-grid-tile data-cy="referral-manager-attachment-item">
                          @if (img.url.endsWith('.pdf')) {
                            <a [href]="img.url" download data-cy="referral-manager-attachment-pdf">
                              <lucide-icon name="file-text" [size]="20" class="large-pdf-icon"></lucide-icon>
                            </a>
                          } @else {
                            <img width="100px" src="{{img.url}}" title="{{img.name}}" data-cy="referral-manager-attachment-image" />
                          }
                        </mat-grid-tile>
                      }
                    </mat-grid-list>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div style="display: flex; flex-direction: column; margin-top: 10px; padding-left: 10px; width: 50%">
              <mat-card class="Card-style" style="height: 345px">
                <mat-card-title-group>
                  <mat-card-title class="Card-title">
                    <mat-label style="font-weight: bold">Treatments Requested (@if (this.selectedRef.ToothIDsJSON && this.selectedRef.ToothIDsJSON.length>0) {
                      <span
                      >Teeth: {{this.selectedRef.ToothIDsJSON}}</span>
                      })
                    </mat-label>
                  </mat-card-title>
                </mat-card-title-group>
                <mat-card-content>
                  <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
                    <mat-list
                      style="overflow-y: auto; font-size: small; border: 0px solid var(--tdo-purple-light); border-radius: 10px; width: 100%; height: 80%;margin: 4%">
                      @if (this.treatmentsSelected && this.treatmentsSelected.length>0 && this.treatmentsSelected[0] !== '') {
                        <div
                          >
                          @for (treat of this.treatmentsSelected; track treat) {
                            <mat-list-item style="border-bottom: 1px solid grey">
                              @for (pro of this.procedures | filterTreatments: treat.toString(); track pro) {
                                <span style="font-size: small"
                                >{{pro.ItemName}}</span>
                              }
                            </mat-list-item>
                          }
                        </div>
                      }
                      @if (this.othTreatments && this.othTreatments.length>0 && this.othTreatments[0] !== '') {
                        <div>
                          @for (Othertreat of this.othTreatments; track Othertreat) {
                            <mat-list-item style="border-bottom: 1px solid grey">
                              @for (pro of this.otherServices | filterOthTreatments: Othertreat.toString(); track pro) {
                                <span style="font-size: small"
                                >{{pro.ItemName}}</span>
                              }
                            </mat-list-item>
                          }
                        </div>
                      }
                    </mat-list>
                  </div>
                </mat-card-content>
              </mat-card>
              <mat-card class="Card-style" style="height: 180px; margin-top: 5px; overflow: hidden;">
                <mat-card-title-group>
                  <mat-card-title class="Card-title">Notes</mat-card-title>
                </mat-card-title-group>
                <mat-card-content>
                  <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
                    <div style="display: flex;">
                      <span style="flex: 70%">Discomfort: {{this.selectedRef.DiscomfortLevel}}</span>
                      <dx-button  icon="newfolder" (onClick)="onClickAddNoteToPatient()"  ></dx-button>
                    </div>
                    <span >Other Note(s):</span>
                    <mat-form-field>
                      <textarea matInput readonly="true" rows="4" [(ngModel)]="selectedRef.Notes"    [attr.data-cy]="'Notes'" ></textarea>
                    </mat-form-field>
                  </div>
                </mat-card-content>
              </mat-card>
              <mat-card class="Card-style" style="height: 180px; margin-top: 5px">
                <mat-card-title-group>
                  <mat-card-title class="Card-title">Appointment</mat-card-title>
                </mat-card-title-group>
                <mat-card-content>
                  <div style="display: flex; flex: 1; flex-direction: column; margin: 5px;justify-content:flex-start">
                    <div style="display: flex; flex: 1; flex-direction: row;" [class.readonly]="true">
                      <mat-label>Location:</mat-label>
                      @if (this.selectedLocation) {
                        <span class="span">{{this.selectedLocation.Name}}</span>
                      }
                    </div>
                    <div style="display: flex; flex: 1; flex-direction: row" [class.readonly]="true">
                      <mat-label>Date:</mat-label>
                      @if (this.appointmentStartDateTime) {
                        <span
                        class="span">{{getDate(appointmentStartDateTime)  | date: 'shortDate'  }}  </span>
                      }
                    </div>
                    <div style="display: flex; flex: 1; flex-direction: row;" [class.readonly]="true">
                      <mat-label>Start Time:</mat-label>
                      @if (this.appointmentStartDateTime) {
                        <span
                        class="span">{{getDate(appointmentStartDateTime)  | date: 'shortTime'  }}  </span>
                      }
                    </div>
                    <div style="display: inline-flex; flex-direction: row;" [class.readonly]="true">
                      <mat-label>Duration:</mat-label>
                      @if (this.appointmentDuration) {
                        <span class="span">{{this.appointmentDuration}}</span>
                      }
                    </div>
                    <div style="display: flex; flex: 1; flex-direction: row; align-self: end">
                      @if (selectedRef.enumReferralStatusID === EnumReferralStatusPending) {
                        <div>
                          <img (click)="createAppointment()" src="../../../assets/icons/icons8_calendar_plus.svg"
                            matTooltip="Create Appointment" style="width: 35px">
                          </div>
                        }
                      </div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
